import React from 'react';
import './Controls.css';

const DAY_OPTIONS = [
  { value: 7, label: '7 days' },
  { value: 30, label: '30 days' },
  { value: 60, label: '60 days' },
  { value: 90, label: '90 days' },
  { value: 365, label: '1 year' },
];

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'open', label: 'Active only' },
  { value: 'closed', label: 'Resolved only' },
];

export default function Controls({ filters, setFilters, mapMode, setMapMode, onRefresh, loading }) {
  return (
    <div className="controls">
      <div className="controls-group">
        <label className="ctrl-label">Period</label>
        <select
          className="ctrl-select"
          value={filters.days}
          onChange={e => setFilters(f => ({ ...f, days: Number(e.target.value) }))}
        >
          {DAY_OPTIONS.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>

      <div className="controls-group">
        <label className="ctrl-label">Status</label>
        <select
          className="ctrl-select"
          value={filters.status}
          onChange={e => setFilters(f => ({ ...f, status: e.target.value }))}
        >
          {STATUS_OPTIONS.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>

      <div className="controls-group controls-search">
        <input
          type="text"
          className="ctrl-search"
          placeholder="Search fires…"
          value={filters.search}
          onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
        />
      </div>

      <div className="controls-group controls-map-mode">
        <label className="ctrl-label">View</label>
        <div className="ctrl-toggle">
          <button
            className={`ctrl-btn ${mapMode === 'heatmap' ? 'active' : ''}`}
            onClick={() => setMapMode('heatmap')}
          >
            Heatmap
          </button>
          <button
            className={`ctrl-btn ${mapMode === 'markers' ? 'active' : ''}`}
            onClick={() => setMapMode('markers')}
          >
            Markers
          </button>
        </div>
      </div>

      <button
        className="ctrl-btn ctrl-refresh"
        onClick={onRefresh}
        disabled={loading}
      >
        {loading ? '…' : '↻'} Refresh
      </button>
    </div>
  );
}
